import useForgotPassword from 'pages/Auth/ForgotPassword/useForgotPassword'
import { FormikProvider } from 'formik'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

import TextFieldFormik from 'components/TextFieldFormik'

import { ButtonPrimary } from 'components/Button/Button'
import TypographySecondary from 'components/Typography/Secondary'
import { StyledLogo } from 'pages/Navigation/MainNavigation'
import { StyledRow } from 'pages/Subnets/panels/Playground/Subnets/Cortext/Settings/SettingsStyles.css'
import HeadingSecondary from 'components/Heading/Secondary'
import Heading from 'share-ui/components/Heading/Heading'

const ForgotPassword = () => {
    const { t } = useTranslation()
    const { formik, forgotPasswordLoading } = useForgotPassword()
    return (
        <StyledCenterFormContainer>
            <StyledRow>
                <StyledLogo src={'/DaturaLogo.svg'} />

                <HeadingSecondary
                    value={t('datura-ai')}
                    type={Heading.types?.h2}
                    style={{ fontSize: 24, lineHeight: 'normal' }}
                />
            </StyledRow>
            <StyledFormContainer>
                <TypographySecondary
                    size='small'
                    value='Please insert your e-mail.
                An e-mail will be sent to you shortly with the link to reset your password.'
                />
                <FormikProvider value={formik}>
                    <TextFieldFormik
                        field_name='email'
                        placeholder={`${t('email')}*`}
                        type='email'
                    />
                </FormikProvider>
                <ButtonPrimary
                    onClick={formik.handleSubmit}
                    disabled={forgotPasswordLoading}
                    loading={forgotPasswordLoading}
                >
                    {t('send')}
                </ButtonPrimary>
            </StyledFormContainer>
        </StyledCenterFormContainer>
    )
}

export default ForgotPassword

export const StyledFormContainer = styled.div`
    padding: 0 87px;
    width: 550px;
    max-width: 550px;

    display: flex;
    flex-direction: column;
    gap: 26px;

    text-align: center;

    margin-top: 20px;
`
export const StyledCenterFormContainer = styled.div`
    align-self: center;
    justify-self: center;
    display: grid;
    width: 100%;
    max-width: 550px;
    justify-items: center;

    overflow: auto;
`
